enum RmaStatusEnum {
    DRAFT = 1,
    AUTHORIZED = 2,
    RECEIVED = 3,
    PROCESSED = 4,
    CANCELLED = 5,
}

export default RmaStatusEnum;
